import {
  SET_DIABETES_OVERVIEW,
  SET_OVERWEIGHT_OVERVIEW,
  SET_LIFEHABITS_OVERVIEW,
  SET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW,
  SET_RISKS_OVERVIEW,
  SET_ENGAGEMENTBENEFICIARY_OVERVIEW,
  SET_EQUIPEMENT_OVERVIEW
} from '@actions/overview'

const defaultState = {
  risksData: null,
  diabetesData: null,
  overweightData: null,
  lifeHabitsData: null,
  hypertensionAndDyslipidemiaData: null,
  engagementBeneficiaryData: null,
  equipmentData: null
}

const overviewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_RISKS_OVERVIEW: {
      const { risksData } = action

      return {
        ...state,
        risksData
      }
    }

    case SET_EQUIPEMENT_OVERVIEW: {
      const { equipmentData } = action
      return {
        ...state,
        equipmentData
      }
    }

    case SET_DIABETES_OVERVIEW: {
      const { diabetesData } = action

      return {
        ...state,
        diabetesData
      }
    }

    case SET_OVERWEIGHT_OVERVIEW: {
      const { overweightData } = action

      return {
        ...state,
        overweightData
      }
    }

    case SET_LIFEHABITS_OVERVIEW: {
      const { lifeHabitsData } = action

      return {
        ...state,
        lifeHabitsData
      }
    }

    case SET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW: {
      const { hypertensionAndDyslipidemiaData } = action

      return {
        ...state,
        hypertensionAndDyslipidemiaData
      }
    }

    case SET_ENGAGEMENTBENEFICIARY_OVERVIEW: {
      const { engagementBeneficiaryData } = action

      return {
        ...state,
        engagementBeneficiaryData
      }
    }

    default:
      return state
  }
}

export default overviewReducer
